import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiPost } from '../lib/api';
import { useAuth } from '../context/AuthContext';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get('session_id');
    apiPost('/auth/google/session', { session_id: sessionId })
      .then((u) => {
        setUser(u);
        window.history.replaceState(null, '', '/account');
        nav('/account', { replace: true });
      })
      .catch(() => nav('/login', { replace: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
